import { createContext } from "react";

export type ToastVariation = "success" | "error" | "info";

export type ToastType = {
  variation?: ToastVariation;
  title: string;
  message: string;
  id: number;
};

export interface BreadcrumbPage {
  name: string;
  href: string;
  current: boolean;
  testId?: string;
}

export interface TabItem {
  name: string;
  href: string;
  current: boolean;
  testId?: string;
}

export type HostServiceContextType = {
  breadcrumbs: BreadcrumbPage[] | undefined;
  setBreadcrumbs: (items: BreadcrumbPage[] | undefined) => void;
  showPrintButton: boolean;
  setShowPrintButton: (show: boolean) => void;
  tabs: TabItem[] | undefined;
  setTabs: (tabs: TabItem[] | undefined) => void;
  toasts: ToastType[];
  addToast: (
    title: string,
    message: string,
    variation?: ToastVariation,
  ) => void;
  removeToast: (id: number) => void;
};

export const HostServiceContext = createContext<
  HostServiceContextType | undefined
>(undefined);
